import './case-list.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListItem from 'components/app-case/list-item';
class CaseList extends Component {
  static propTypes = {
    // 精品推荐or精选案例推荐列表
    list: PropTypes.array,
    // 0=精品推荐，1=精选案例推荐
    listType: PropTypes.number,
  };

  constructor(props) {
    super(props);
  }
  render() {
    const { list, listType } = this.props;
    return (
      <div className="common-wrap">
        {listType === 0 ? (
          <div className="goods-recommend">精品推荐</div>
        ) : (
          <div className="goods-select-recommend">精选案例推荐</div>
        )}
        <ul className="case-list">
          {list.map((v, i) => (
            <ListItem key={i} {...v} listType={listType} />
          ))}
        </ul>
      </div>
    );
  }
}

export default CaseList;
